import { Controller } from "stimulus";
import queryString from "query-string";

export default class extends Controller {
  static targets = ["paginate"];
  initialize() {
    const params = queryString.parse(window.location.search);

    if (params.article) {
      const articleCheckboxes = document.querySelectorAll(
        `[id^=paginate-articles-]`
      );

      articleCheckboxes.forEach((checkbox) => {
        const page = (parseInt(checkbox.dataset.page) + 4) / 4;

        if (page < parseInt(params.article)) {
          checkbox.checked = true;
        }
      });
    }

    if (params.product) {
      const productCheckboxes = document.querySelectorAll(
        `[id^=paginate-products-]`
      );

      productCheckboxes.forEach((checkbox) => {
        const page = (parseInt(checkbox.dataset.page) + 4) / 4;

        if (page <= parseInt(params.product)) {
          checkbox.checked = true;
        }
      });
    }
  }

  handlePagination(e) {
    const objectType = e.currentTarget.dataset.objectType;
    const params = queryString.parse(window.location.search);

    const page = params[objectType];

    if (!page) {
      history.pushState(
        {},
        document.title,
        `${window.location.href}&${objectType}=2`
      );
    } else {
      params[objectType] = parseInt(page) + 1;

      history.pushState(
        {},
        document.title,
        `${window.location.origin}${
          window.location.pathname
        }?${queryString.stringify(params)}`
      );
    }
  }
}
